var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"googlewrapper"},[_c('img',{attrs:{"width":"100%","height":"100%","src":_vm.getImageURL()}})])}
var staticRenderFns = []

export { render, staticRenderFns }